import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Modal } from "ui/Modal"
import { Text } from "ui/Typography"
import AddStaffForm from "./AddStaffForm"
import styles from "./AddStaffModal.module.css"
import { useDevice } from "hooks/useDevice"
import { ResponsivePage } from "ui/ResponsivePage"

const AddStaffModal = ({ open, onCancel, onSave, userId, staffId, editMode = false, getProfileAction, updateProfileAction, customTitle, memberType = "staff" }) => {
  const [t] = useTranslation()
  const { isMobile } = useDevice()

  const titleText = customTitle ?? (editMode ? t("staff.edit_staff_modal.title") : t("staff.add_staff_modal.title"))

  return (
    <>
      {isMobile ? (
        open && (
          <ResponsivePage pageTitle={titleText}>
            <AddStaffForm
              key={staffId || "new"}
              open={open}
              onCancel={onCancel}
              onSave={onSave}
              userId={userId}
              staffId={staffId}
              editMode={editMode}
              isFullScreen={false}
              getProfileAction={getProfileAction}
              updateProfileAction={updateProfileAction}
            />
          </ResponsivePage>
        )
      ) : (
        <Modal
          open={open}
          onCancel={onCancel}
          width={800}
          closable
          maskClosable={false}
          destroyOnClose
          className={styles.staffModal}
          title={
            <div className={styles.header}>
              <Text className={styles.title} size="24">
                {titleText}
              </Text>
            </div>
          }
        >
          <AddStaffForm
            key={staffId || "new"}
            open={open}
            onCancel={onCancel}
            onSave={onSave}
            userId={userId}
            staffId={staffId}
            editMode={editMode}
            isFullScreen={false}
            getProfileAction={getProfileAction}
            updateProfileAction={updateProfileAction}
            memberType={memberType}
          />
        </Modal>
      )}
    </>
  )
}

AddStaffModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  staffId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  editMode: PropTypes.bool,
  getProfileAction: PropTypes.func,
  updateProfileAction: PropTypes.func,
  customTitle: PropTypes.string,
  memberType: PropTypes.string
}

export default AddStaffModal
